var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DList inner_center"},_vm._l((_vm.list),function(vo,idx){return _c('div',{key:idx},[_c('DListHeader',_vm._g({staticClass:"DListHeader",attrs:{"item":vo,"idx":idx}},_vm.$listeners)),_vm._v(" "),_c('PicList',{staticClass:"PicList",attrs:{"pic-list":vo.pictures}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }